import Constants from './PatientDetailsConstant';

let initialState = {
    loadingProfile: true,
    profileDate: {},
    profileError: {}
};

export default function PatientReducer(state = initialState, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Constants.ACTIONS.GET_PROFILE_DATA_SUCCESS:
            newState.loadingProfile = false;
            newState.profileDate = action.payload;
            break;
        case Constants.ACTIONS.GET_PROFILE_DATA_FAILED:
            newState.loadingProfile = false;
            newState.profileError = action.payload;
            break;
        case Constants.ACTIONS.LOGOUT_SUCCESS:
            newState.loadingProfile = false;
            newState.profileDate = {};
            break;
        default:
            break;
    }
    return newState;
}